const PollData = [
{
    pollTitle: "School Fair Food Truck Voting",
    pollQuestion: "Click below which type of food you would like to have at the School Fair",
    optionTitle: ["Mexican Food", "American Food", "Snacks Food"],
    optionDescription: ["Bringing tacos and burritos", "Bringing hotdogs and hamburgers", "Bringing snacks such as chips, ice-cream, and other finger-foods"]

}

]

export default PollData